var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.isStaging || _vm.isDevelopment || _vm.isLocal ? _c('div', {
    staticClass: "the_environment_callout font-weight-bold",
    class: _vm.cosmicEnvironment
  }, [_vm.isLocal ? _c('p', [_vm._v("WARNING: You are running local silly goose.")]) : _vm._e(), _vm.isDevelopment ? _c('p', [_vm._v("WARNING: You are in the development environment.")]) : _vm._e(), _vm.isStaging ? _c('p', [_vm._v("WARNING: You are in the staging environment.")]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };